var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 52.09 68.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke-width:0px;}.cls-3{fill:#5e205d;}.cls-4{fill:#4563ab;}.cls-5{fill:#d5398c;}.cls-6{fill:#ee7913;}.cls-7{fill:#ffd62c;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 52.09,
    height: 68.05
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16304"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    className: "cls-4",
    d: "m31.64,1.76c5.01,1.46,11.09,3.23,14.67,9.24,3.16,5.3,3.71,12.7.54,17.93-1.35,2.55-3.43,4.63-5.98,5.98-1.59.75-4.21,1.51-6.52,3.47-.62.49-1.17,1.06-1.64,1.69-1.09,1.49-1.15,2.74-3.29,4.98-1.91,2.13-4.34,3.74-7.05,4.67-1.07.35-6.64,2.07-12-.36-3.39-1.44-5.82-4.5-6.47-8.12-.36-2.19-.03-4.44.95-6.44.99-1.99,1.8-2.04,3.07-4.43,1.07-1.8,1.64-3.85,1.65-5.94-.09-1.98-.74-3.9-1.87-5.52-1.27-1.92-2.23-1.96-3.33-3.73-.87-1.45-1.35-3.11-1.38-4.8.02-1.55.43-3.07,1.18-4.42C8.31-1.32,22.56-.88,31.64,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    className: "cls-5",
    d: "m4.99,46.38c1.12-1.22,2.33-2.36,3.62-3.4,1.14-.9,1.07-.69,1.78-1.33,1.5-1.39,2.76-3.03,3.71-4.84,1.95-3.58,1.15-4.68,2.65-7.27,1.75-2.86,4.65-4.85,7.95-5.45,2.62-.39,5.28.26,7.42,1.82,1.29.99,2.37,2.23,3.18,3.64.3.51.62,1.11,2.12,5.45,1.14,3.3,1.16,3.54,1.63,4.35.82,1.39,1.87,2.62,3.1,3.66,1.03.89,2.16,1.65,3.38,2.25,1.06.58,2.01,1.35,2.81,2.25,1.21,1.49,2.17,3.15,2.85,4.94.14.33,2.48,6.05-1.06,11.03-3.62,4.98-10.58,6.08-15.56,2.46-.52-.38-1-.79-1.44-1.25-1.66-1.91-2.74-4.25-3.1-6.76-.73-3.68.28-5.95-1.42-7.94-.38-.55-.95-.94-1.6-1.09-1-.31-2.08-.21-3,.29-.75.37-1.34,1.01-1.63,1.8-1.19,2.75.38,4.46-.24,7.79-.38,1.88-1.24,3.63-2.48,5.09-1.05,1.39-2.42,2.5-3.99,3.25-.05.02-.12.05-.2.09-2.13.84-4.46,1.02-6.69.52-1.23-.15-2.42-.51-3.52-1.07-1.71-.98-3.08-2.45-3.94-4.22-1.45-2.98-1.72-6.4-.74-9.56.83-2.54,2.32-4.19,4.4-6.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    className: "cls-3",
    d: "m34.36,38.38c1.06-.88,2.23-1.61,3.48-2.17-.12-.36-.26-.76-.42-1.23-1.5-4.34-1.82-4.95-2.12-5.45-.81-1.41-1.89-2.65-3.18-3.64-2.14-1.55-4.8-2.21-7.42-1.82-3.31.61-6.2,2.59-7.95,5.45-1.5,2.59-.7,3.69-2.65,7.27-.95,1.82-2.21,3.45-3.71,4.85-.71.64-.65.43-1.78,1.33-1.01.82-1.97,1.69-2.88,2.62,1.18,1.65,2.79,2.95,4.65,3.76,5.36,2.42,10.93.71,12,.36,2.71-.93,5.14-2.53,7.05-4.67,2.14-2.24,2.2-3.49,3.29-4.98.47-.63,1.03-1.2,1.64-1.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    className: "cls-7",
    d: "m18.59,24.32c0-4.1,3.32-7.42,7.42-7.42s7.42,3.32,7.42,7.42-3.32,7.42-7.42,7.42-7.42-3.32-7.42-7.42h0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    className: "cls-6",
    d: "m24.69,24.08c-2.1.4-4.05,1.33-5.67,2.71,1.36,3.86,5.6,5.89,9.46,4.52,2.15-.76,3.84-2.47,4.56-4.64-.29-.28-.6-.54-.92-.78-2.14-1.55-4.8-2.2-7.42-1.82"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.68fc782219abf56984a84311f335dac3.svg";
export { ForwardRef as ReactComponent };